import React from 'react';
import '@builder.io/widgets';
import { builder, BuilderComponent } from '@builder.io/react';
import { BUILDER_API_KEY } from '../../../../utils/environment';
import { SHOP_LOCALE } from 'src/scripts/utils/constants';
import { getSharedUserTargetingAttributes } from 'src/scripts/utils/builder';
import { pickBy } from 'lodash-es';

// Init builder
if (BUILDER_API_KEY && !builder.apiKey) builder.init(BUILDER_API_KEY);

const TabBottomContent = ({ sizeGuideTab }: { sizeGuideTab: string[] }) => {
  let builderContent;
  if (BUILDER_API_KEY) {
    builderContent = (
      <BuilderComponent
        model={'size-guide-tab-content'}
        data={{ ...getSharedUserTargetingAttributes() }}
        locale={SHOP_LOCALE}
        options={{
          userAttributes: {
            ...getSharedUserTargetingAttributes(),
            ...pickBy({
              sizeGuideTab,
            }),
          },
        }}
      />
    );
  }
  return <>{builderContent ?? null}</>;
};

export default TabBottomContent;
